// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-change-menu {
  padding: 17px 15px;
  box-shadow: 0px 0px 9px rgba(131, 164, 249, 0.15);
  border-radius: 4px;
}
.status-change-menu .status-change-menu-btn {
  width: 100px;
  height: 29px;
  border: none;
  border-radius: 4px;
}
.status-change-menu .accept-btn {
  background-color: #FDAB3D !important;
  margin-bottom: 15px !important;
}
.status-change-menu .reject-btn {
  background-color: #E2445C !important;
}`, "",{"version":3,"sources":["webpack://./src/features/bookings/common/status-change-menu/status-change-menu.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,iDAAA;EACA,kBAAA;AACJ;AAAI;EACI,YAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AAER;AAAI;EACI,oCAAA;EACA,8BAAA;AAER;AACI;EACI,oCAAA;AACR","sourcesContent":["@import \"../../../../styles/variables\";\n\n.status-change-menu {\n    padding: 17px 15px;\n    box-shadow: 0px 0px 9px rgba(131, 164, 249, 0.15);\n    border-radius: 4px;\n    .status-change-menu-btn{\n        width: 100px;\n        height: 29px;\n        border: none;\n        border-radius: 4px;\n    }\n    .accept-btn {\n        background-color: #FDAB3D !important;\n        margin-bottom: 15px !important;\n    }\n\n    .reject-btn {\n        background-color: #E2445C !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
